export const useFrequenzaSchedulazione = () => {

    const frequenze = [
        {
            id: 1,
            descrizione: 'Ogni giorno',
        },
        {
            id: 2,
            descrizione: 'Ogni settimana',
        },
        {
            id: 3,
            descrizione: 'Ogni mese',
        },
        {
            id: 4,
            descrizione: 'Ogni anno',
        },
        /*{
            id: 5,
            descrizione: 'Ogni ora',
        },
        {
            id: 6,
            descrizione: 'Ogni minuto',
        }*/
    ];

    const giorniSettimana = [
        {
            id: 1, // TODO 1 oppure 0?
            descrizione: 'Lunedì',
        },
        {
            id: 2,
            descrizione: 'Martedì',
        },
        {
            id: 3,
            descrizione: 'Mercoledì',
        },
        {
            id: 4,
            descrizione: 'Giovedì',
        },
        {
            id: 5,
            descrizione: 'Venerdì',
        },
        {
            id: 6,
            descrizione: 'Sabato',
        },
        {
            id: 0,
            descrizione: 'Domenica',
        }
    ];

    const mesi = [
        {
            id: 1,
            descrizione: 'Gennaio',
        },
        {
            id: 2,
            descrizione: 'Febbraio',
        },
        {
            id: 3,
            descrizione: 'Marzo',
        },
        {
            id: 4,
            descrizione: 'Aprile',
        },
        {
            id: 5,
            descrizione: 'Maggio',
        },
        {
            id: 6,
            descrizione: 'Giugno',
        },
        {
            id: 7,
            descrizione: 'Luglio',
        },
        {
            id: 8,
            descrizione: 'Agosto',
        },
        {
            id: 9,
            descrizione: 'Settembre',
        },
        {
            id: 10,
            descrizione: 'Ottobre',
        },
        {
            id: 11,
            descrizione: 'Novembre',
        },
        {
            id: 12,
            descrizione: 'Dicembre',
        }
    ];

    const getDescrizioneFrequenza = (frequenza) => {
        return frequenze.find(f => f.id === frequenza)?.descrizione || '';
    }

    const getDescrizioneGiornoSettimana = (giorno) => {
        return giorniSettimana.find(f => f.id === giorno)?.descrizione || '';
    }

    const getDescrizioneMese = (mese) => {
        return mesi.find(f => f.id === mese)?.descrizione || '';
    }

    return {
        frequenze,
        giorniSettimana,
        mesi,
        getDescrizioneFrequenza,
        getDescrizioneGiornoSettimana,
        getDescrizioneMese,
    };
};
